module.exports = __webpack_public_path__ + "static/carrier-pickup-and-dropoff-c679077dabd44e9c408d30798dd44cc8.png";